module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAARAgMAAAC6FoSjAAAACVBMVEUAAAD///////9zeKVjAAAAAnRSTlMARAciSLEAAAAYSURBVAjXYwxlAAEWCEU8YFwFoULJ0wAAlVICslNuyLYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mobile_menu.png
// module id = 668
// module chunks = 0